module.exports = __webpack_public_path__ + "img/language_active.b1d5e79e.svg";